import { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import Popup from "reactjs-popup";
import { Trans } from "react-i18next";
import { t } from "i18next";

const AccessCodeWarning = ({ workShopName="", open=true, onClose, onConfirm }) => {

    const [openPopup, setOpenPopup] = useState(open);

    const handleClose = () => {
        if(onClose) onClose();
        setOpenPopup(false);
    }

    return (
        <Popup contentStyle={{textAlign: 'center'}} open={openPopup} modal onClose={handleClose}>
            <Box className="popup-container">
                <Typography className="popup-title">
                    <Trans i18nKey="form:access_code_popup_title" />
                </Typography>
                <Box className="popup-detail">
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: workShopName ? t("form:access_code_popup_content_video", {
                                date: new Date(new Date().getTime() + 60 * 24 * 60 * 60 * 1000).toLocaleDateString('sv-SE'),
                                name: workShopName
                            }) : t("form:access_code_popup_content")
                        }}
                    >
                    </Typography>
                </Box>
                <Box className="popup-button-container">
                    <Button
                        className="loading-button"
                        variant="outlined"
                        onClick={handleClose}
                    >
                        <Trans i18nKey="form:access_code_popup_button" />
                    </Button>
                </Box>
            </Box>
        </Popup>
    )
}

export default AccessCodeWarning